import { inject, Injectable } from '@angular/core';
import { finalize, type Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { AuthService } from '../authentication/_services/auth.service';
import { LoadingScreenService } from '../shared/components/loading-screen/loading-screen.service';

import type { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private loadingScreenService = inject(LoadingScreenService);
  private authService = inject(AuthService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const showSpinner = req.headers.has('X-Spinner');
    let _loaderToken: string | undefined;
    if (showSpinner) {
      _loaderToken = this.loadingScreenService.show();
    }

    const tokenWithBearer = localStorage.getItem(this.authService.tokenKey)?.trim();
    const token = tokenWithBearer?.startsWith('Bearer ') ? tokenWithBearer.substring('Bearer '.length).trim() : tokenWithBearer;

    const isBackendRequest = req.url.includes(environment.serverApp);
    const isPublicAuthRequest = this.isPublicAuthRequest(req.url);
    const authReq = token && isBackendRequest && !isPublicAuthRequest ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

    return next.handle(authReq).pipe(
      finalize(() => {
        if (showSpinner) {
          this.loadingScreenService.hide(_loaderToken);
        }
      })
    );
  }

  private isPublicAuthRequest(url: string): boolean {
    try {
      return /\/(login|requestOtp|forgotPassword|replaceForgottenPassword)$/.test(new URL(url, 'http://localhost').pathname);
    } catch {
      return /\/(login|requestOtp|forgotPassword|replaceForgottenPassword)(?:\?|$)/.test(url);
    }
  }
}
